import React, { FC, memo, useMemo } from 'react'

import { HtmlWidget } from '@/components/HtmlWidget/HtmlWidget'
import { sliderItemImgPlaceholder } from '@/constants/icons'
import useStore from '@/store/useStore'
import { TileProps } from '@/types/componentsPropsTypes'
import { findBestImage } from '@/utils/utils'

import { HtmlWidgetLineTileElem, HtmlWidgetTileElem } from './styles'
import { TileImage } from './TileImage'
import { getTileProps } from '../Lines/utils'

type HtmlWidgetTileProps = {
  url?: string
  renderInTile?: boolean
}

const HtmlWidgetTileRaw: FC<TileProps & HtmlWidgetTileProps> = ({
  url,
  renderInTile,
  focusId,
  data,
  isGridTile,
  tileSize,
  tileShape,
  handleToggle,
  onMouseOverTile,
  isLineTile,
}) => {
  const { isDisabledHtmlWidgets } = useStore(
    (state) => state.common.appSettings,
  )

  const renderHtmlWidget = renderInTile && !isDisabledHtmlWidgets

  const imgUrl = useMemo(
    () =>
      findBestImage(data.image?.sources, {
        targetWidth: getTileProps(tileShape, tileSize).w,
        targetShape: tileShape,
      })?.url,
    [data.id],
  )

  const onSelected = () => {
    if (!isGridTile) {
      handleToggle?.({ tileData: data, focusId })
    }
  }

  const tileClassName = isGridTile ? 'grid__item' : 'slider__item'
  const TileComponent: React.ElementType = isLineTile
    ? HtmlWidgetLineTileElem
    : HtmlWidgetTileElem
  const tileProps = isLineTile
    ? { onClick: onSelected }
    : { onSelected: onSelected, focusId }

  return (
    <TileComponent
      className={tileClassName}
      $tileShape={tileShape}
      $tileSize={tileSize}
      onMouseEnter={() => onMouseOverTile?.(data, focusId)}
      {...tileProps}
    >
      {renderHtmlWidget ? (
        <HtmlWidget url={url} />
      ) : (
        <TileImage url={imgUrl} errorPlaceholder={sliderItemImgPlaceholder} />
      )}
    </TileComponent>
  )
}

export const HtmlWidgetTile = memo(HtmlWidgetTileRaw)
